import { useState } from "react";
import type { FAQSection } from "@/types/content";

interface Props {
  section: FAQSection;
}

export default function FAQSectionBlock({ section }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-slate-50">
      <div className="max-w-3xl mx-auto">
        {section.title && (
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 text-center mb-10">
            {section.title}
          </h2>
        )}
        <div className="space-y-3">
          {section.items.map((item, index) => (
            <div
              key={item._key}
              className="bg-white rounded-xl border border-slate-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-colors"
                onClick={() =>
                  setOpenIndex(openIndex === index ? null : index)
                }
              >
                <span className="text-sm font-medium text-slate-800 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-slate-400 transition-transform shrink-0 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-slate-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}